<mat-dialog-content class="welcome-modal">
  <header class="welcome-modal__header">
    <h2 class="welcome-modal__title">
      We have a new look, and there’s much more to come
    </h2>
    <button class="btn-nude welcome-modal__close-btn" mat-dialog-close>
      <app-icon-close
        width="16"
        height="16"
        color="#011835
      "
      ></app-icon-close>
    </button>
    <app-icon-sun></app-icon-sun>
  </header>
  <div class="welcome-modal__body">
    <p class="welcome-modal__text">
      Welcome to the beginning of your freshly redesigned Best Egg experience.
      We’re thrilled to start sharing our new look with you, and we hope you
      enjoy the makeover as much as we’re enjoying creating it.
    </p>
    <p class="welcome-modal__text">
      Our appearance isn’t the only thing we’re updating, however. We’ve also
      upgraded our login experience so you can now access information about all
      of your Best Egg accounts from one place! Please take some time to
      explore, and keep your eyes peeled – you’ll be seeing more great changes
      in the near future!
    </p>
    <div class="btn-container">
      <button class="befh-btn befh-btn--primary" mat-dialog-close>
        Start exploring
      </button>
    </div>
  </div>
</mat-dialog-content>
